import { useCouponStatusLabel } from '../../../molecules/CouponStatus/CouponStatus'
import type { CouponStatus } from '../../../types/coupons.types'

const statuses: CouponStatus[] = ['active', 'scheduled', 'expired', 'exhausted', 'inactive']

export const useStatusOptions = () => {
	const label = useCouponStatusLabel()
	return statuses.map((status) => ({ value: status, label: label(status) }))
}
